<template>
  <v-container fluid>
    <v-row class="common-card-row">
      <v-col class="common-card-col">
        <p>Estate Planning</p>
        <div :id="`con_${id}`" class="container pa-0">
          <div :id="`${id}`" class="svg-container"></div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as d3 from "d3";

export default {
  name: "EstatePlanningDiagram",
  data() {
    return {
      id: "dg_1",
      svg: null,
      div: null,
      data: null,
    };
  },
  mounted() {
    // this.getData();
    this.initialize();
  },
  methods: {
    initialize() {
      // Initialize the diagram
      const x = 60;
      const y = 1;
      this.createSvg();

      this.drawIncomer(x, y);

      /*
      this.data.forEach((estate) => {
        this.drawEstate(incomer, estate);
      });
      */

      const estate = null; // This will include the estate data

      // Line 1 --------------------------------------------------------------
      const estate_area_1 = this.svg.append("g").attr("transform", `translate(${x},${y})`);
      this.drawLine(estate_area_1, 0, 20, 0, 0, -4.5, 1.4);
      this.drawSemiDetachedHouse(
        [
          { number: 1, node: 70, before: 237.9, after: 237.7 },
          { number: 2, node: 34, before: 237.9, after: 237.7 },
        ],
        55.5,
        6,
        0
      );
      this.drawSemiDetachedHouse(
        [
          { number: 3, node: 47, before: 237.7, after: 237.5 },
          { number: 4, node: 83, before: 237.8, after: 237.5 },
        ],
        55.5,
        11,
        0
      );
      this.drawSemiDetachedHouse(
        [
          { number: 5, node: 74, before: 237.7, after: 237.2 },
          { number: 6, node: 73, before: 237.7, after: 237.2 },
        ],
        55.5,
        16,
        0
      );
      this.drawLine(estate_area_1, 2, 0, 6, 0, -10.5, 11.5);
      this.drawLine(estate_area_1, 32, 0, 6, 0, -10.7, 21.5);
      this.drawDetachedHouse({ number: 7, node: 178, before: 237.6, after: 237 }, 61, 20.7, 270);
      this.drawSemiDetachedHouse(
        [
          { number: 8, node: 208, before: 237.6, after: 237 },
          { number: 9, node: 264, before: 237.6, after: 237 },
        ],
        66,
        22,
        270
      );
      this.drawDetachedHouse({ number: 10, node: 225, before: 237.6, after: 237 }, 71, 20.7, 270);
      this.drawSemiDetachedHouse(
        [
          { number: 11, node: 248, before: 237.6, after: 237 },
          { number: 12, node: 249, before: 237.6, after: 237.0 },
        ],
        76,
        22,
        270
      );
      this.drawLine(estate_area_1, 5, 0, 0, 0, -7, 24, 90);
      this.drawTooltip(estate_area_1, "Line 1");

      // Line 2 --------------------------------------------------------------
      const estate_area_2 = this.svg.append("g").attr("transform", `translate(${x - 25},${y})`);
      this.drawLine(estate_area_2, 36.5, 0, 5.2, 0, 10, 26.5);
      this.drawSemiDetachedHouse(
        [
          { number: 13, node: 327, before: 237.6, after: 236.9 },
          { number: 14, node: 320, before: 237.6, after: 236.9 },
        ],
        72,
        29.1,
        90
      );
      this.drawSemiDetachedHouse(
        [
          { number: 15, node: 314, before: 237.6, after: 236.9 },
          { number: 16, node: 276, before: 237.6, after: 236.9 },
        ],
        65.5,
        29.1,
        90
      );
      this.drawDetachedHouse({ number: 17, node: 289, before: 237.6, after: 236.9 }, 59, 29.2, 90);
      this.drawLine(estate_area_2, 25, 0, 0, 0, 2.8, 39, 90);
      this.drawDetachedHouse({ number: 18, node: 387, before: 237.5, after: 236.7 }, 50.2, 32, 0);
      this.drawDetachedHouse({ number: 19, node: 342, before: 237.5, after: 236.6 }, 50.2, 35, 0);
      this.drawSemiDetachedHouse(
        [
          { number: 20, node: 388, before: 237.4, after: 236.5 },
          { number: 21, node: 349, before: 237.4, after: 236.5 },
        ],
        50.2,
        39,
        0
      );
      this.drawDetachedHouse({ number: 22, node: 337, before: 237.4, after: 236.4 }, 50.2, 43, 0);
      this.drawDetachedHouse({ number: 23, node: 406, before: 237.4, after: 236.3 }, 50.2, 46, 0);
      this.drawLine(estate_area_2, 32, 0, 0, 0, 15.3, 51.5, 0);
      this.drawDetachedHouse({ number: 24, node: 629, before: 237.2, after: 235.8 }, 53.2, 50.6, 270);
      this.drawSemiDetachedHouse(
        [
          { number: 25, node: 563, before: 237.2, after: 235.6 },
          { number: 26, node: 502, before: 237.2, after: 235.6 },
        ],
        57.2,
        52,
        270
      );
      this.drawSemiDetachedHouse(
        [
          { number: 27, node: 611, before: 237.1, after: 235.4 },
          { number: 28, node: 562, before: 237, after: 235.4 },
        ],
        62.2,
        52,
        270
      );
      this.drawSemiDetachedHouse(
        [
          { number: 29, node: 682, before: 237.1, after: 235.3 },
          { number: 30, node: 676, before: 237.1, after: 235.3 },
        ],
        67.2,
        52,
        270
      );
      this.drawDetachedHouse({ number: 31, node: 619, before: 237.1, after: 235.3 }, 71.2, 50.6, 270);
      this.drawDetachedHouse({ number: 32, node: 639, before: 237.1, after: 235.2 }, 74.2, 50.6, 270);
      this.drawLine(estate_area_2, 5, 0, 0, 0, 10.3, 36.5, 0);
      this.drawTooltip(estate_area_2, "Line 2");

      // Line 3 --------------------------------------------------------------
      const estate_area_3 = this.svg.append("g").attr("transform", `translate(${x - 25},${y})`);
      this.drawLine(estate_area_3, 13, 0, 0, 0, 4, 38.5, 90);
      this.drawDetachedHouse({ number: 33, node: 458, before: 237.4, after: 236.6 }, 42, 35.5, 180);
      this.drawSemiDetachedHouse(
        [
          { number: 35, node: 539, before: 237.4, after: 236.6 },
          { number: 34, node: 556, before: 237.4, after: 236.6 },
        ],
        43.2,
        40,
        180
      );
      this.drawLine(estate_area_3, 5, 0, 0, 0, 5.5, 44.8, 180);
      this.drawDetachedHouse({ number: 36, node: 522, before: 237.3, after: 236.6 }, 41, 44, 270);
      this.drawLine(estate_area_3, 13, 0, 0, 0, -1, 51.2, 90);
      this.drawDetachedHouse({ number: 37, node: 785, before: 237.3, after: 236.6 }, 37, 48, 180);
      this.drawDetachedHouse({ number: 38, node: 614, before: 237.3, after: 236.6 }, 37, 52, 180);
      this.drawDetachedHouse({ number: 39, node: 688, before: 237.3, after: 236.6 }, 37, 56, 180);
      this.drawLine(estate_area_3, 42, 0, 0, 0, 5.5, 57.6, 180);
      this.drawDetachedHouse({ number: 40, node: 817, before: 237.3, after: 236.5 }, 40, 60.5, 90);
      this.drawDetachedHouse({ number: 41, node: 860, before: 237.3, after: 236.5 }, 42, 60.5, 90);
      this.drawDetachedHouse({ number: 42, node: 861, before: 237.3, after: 236.5 }, 44, 60.5, 90);
      this.drawSemiDetachedHouse(
        [
          { number: 44, node: 701, before: 237.3, after: 236.6 },
          { number: 43, node: 778, before: 237.3, after: 236.6 },
        ],
        49,
        60.3,
        90
      );
      this.drawDetachedHouse({ number: 45, node: 702, before: 237.2, after: 236.5 }, 51, 60.5, 90);
      this.drawSemiDetachedHouse(
        [
          { number: 47, node: 895, before: 237.2, after: 236.5 },
          { number: 46, node: 900, before: 237.2, after: 236.5 },
        ],
        56,
        60.3,
        90
      );
      this.drawSemiDetachedHouse(
        [
          { number: 49, node: 813, before: 237.1, after: 236.5 },
          { number: 48, node: 755, before: 237.1, after: 236.5 },
        ],
        61,
        60.3,
        90
      );
      this.drawSemiDetachedHouse(
        [
          { number: 51, node: 835, before: 237.1, after: 236.5 },
          { number: 50, node: 780, before: 237.1, after: 236.5 },
        ],
        66,
        60.3,
        90
      );
      this.drawSemiDetachedHouse(
        [
          { number: 53, node: 906, before: 237.1, after: 236.4 },
          { number: 52, node: 898, before: 237.1, after: 236.4 },
        ],
        71,
        60.3,
        90
      );
      this.drawSemiDetachedHouse(
        [
          { number: 55, node: 899, before: 237.1, after: 236.5 },
          { number: 54, node: 886, before: 237.1, after: 236.5 },
        ],
        76,
        60.3,
        90
      );
      this.drawTooltip(estate_area_3, "Line 3");

      // Line 4 --------------------------------------------------------------
      const estate_area_4 = this.svg.append("g").attr("transform", `translate(${x - 25},${y})`);
      this.drawNewLoad(estate_area_4);
    },
    createSvg() {
      this.svg = d3
        .select(`div#${this.id}`)
        .append("svg")
        .attr("viewBox", [-25, -10, 180, 80])
        .classed("svg-content1", true);
    },
    drawNewLoad(estate_area) {
      this.drawLine(estate_area, 30, 0, 20.5, 0, 11.5, 46.5, 90, "#FFA500");
      this.drawTooltip(estate_area, "Line 4");
      // add text to the diagram
      this.svg
        .append("text")
        .attr("x", 71)
        .attr("y", 39)
        .text("50kW (New Load)")
        .attr("font-size", 2)
        .attr("fill", "#FFA500")
        .attr("text-anchor", "middle")
        .attr("transform", "translate(0, 3)");
    },
    drawIncomer(x, y) {
      const incomer = this.svg
        .append("g")
        .attr("id", "incomer")
        .attr("class", "incomer")
        .attr("transform", `translate(${x},${y})`);

      this.drawLine(incomer, 3, 0, 6, 0, 0, 1.5);
      this.drawTransformer(incomer);
      this.drawLine(incomer, 3, 0, 6, 0, -7.5, 1.5);

      incomer.attr("transform", "rotate(90, 0, 0)");
      incomer.attr("transform", "translate(57, -3.6) rotate(90)");
    },
    drawLine(canvas, x1, y1, x2, y2, x, y, rotate = 0, color = "#1b428b") {
      const centerX = (x1 + x2) / 2;
      const centerY = (y1 + y2) / 2;

      canvas
        .append("line")
        .style("stroke", color)
        .style("stroke-width", 0.4)
        .attr("x1", x1)
        .attr("y1", y1)
        .attr("x2", x2)
        .attr("y2", y2)
        .attr("transform", `translate(${x}, ${y}) rotate(${rotate}, ${centerX}, ${centerY})`);
    },
    drawTransformer(incomer) {
      incomer
        .append("path")
        .attr("fill", "none")
        .attr("stroke", "#1b428b")
        .attr("stroke-width", 0.2)
        .attr("d", d3.symbol().size(6))
        .attr("transform", "translate(0,1.5)");

      incomer
        .append("path")
        .attr("fill", "none")
        .attr("stroke", "#1b428b")
        .attr("stroke-width", 0.2)
        .attr("d", d3.symbol().size(6))
        .attr("transform", "translate(1.5,1.5)");

      this.drawTooltip(incomer, "Substation: 11kV/416V 800kVA Transformer");
    },
    drawTooltip(elementh, text) {
      const tooltip = d3
        .select(`div#${this.id}`)
        .append("div")
        .style("position", "absolute")
        .style("visibility", "hidden")
        .style("background", "rgba(255, 255, 255, 0.8)")
        .style("border", "1px solid #ccc")
        .style("padding", "5px")
        .style("border-radius", "0px")
        .style("pointer-events", "none")
        .text(text);

      elementh.on("mouseover", function () {
        tooltip.style("visibility", "visible");

        d3.select(this)
          .selectAll("line, path")
          .each(function () {
            const currentStroke = d3.select(this).style("stroke");
            d3.select(this).attr("original-stroke", currentStroke);
          })
          .style("stroke", "#f00")
          .style("transition", "stroke 0.3s ease-in-out");
      });
      elementh.on("mousemove", function (event) {
        tooltip.style("top", event.pageY - 100 + "px").style("left", event.pageX - 250 + "px");
      });
      elementh.on("mouseout", function () {
        tooltip.style("visibility", "hidden");

        d3.select(this)
          .selectAll("line, path")
          .style("stroke", function () {
            return d3.select(this).attr("original-stroke") || "#1b428b";
          })
          .style("transition", "stroke 0.3s ease-in-out");
      });
    },
    drawEstate(data, estate) {
      // Not implemented
      //this.drawLine(incomer, estate.direction - 90, estate.number_of_houses * 7, 0, 0, -4.5, 1.4);
      //this.drawSemiDetachedHouse(estate);
    },
    drawDetachedHouse(house, x, y, rotate = 0) {
      const lineStartX = 3,
        lineStartY = 0;
      const lineEndX = 0,
        lineEndY = 0;
      const pathX = 3.5,
        pathY = 0;

      const h = this.svg
        .append("g")
        .attr("class", "detached-house")
        .attr("transform", `translate(${x},${y}) rotate(${rotate}, ${pathX / 2}, ${pathY})`);

      h.append("line")
        .style("stroke", "#1b428b")
        .style("stroke-width", 0.2)
        .attr("x1", lineStartX)
        .attr("y1", lineStartY)
        .attr("x2", lineEndX)
        .attr("y2", lineEndY);

      h.append("path")
        .attr("fill", "none")
        .attr("stroke", "#1b428b")
        .attr("stroke-width", 0.2)
        .attr("d", d3.symbol().size(1))
        .attr("transform", `translate(${pathX}, ${pathY})`);

      const offsetDistance = 1;
      let textX, textY;

      if (rotate === 0) {
        textX = pathX + 1.7;
        textY = pathY - offsetDistance + 1.5;
      } else if (rotate === 90) {
        textX = pathX + offsetDistance + 1;
        textY = pathY;
      } else if (rotate === 180) {
        textX = pathX + 2;
        textY = pathY + offsetDistance - 1.5;
      } else if (rotate === 270) {
        textX = pathX + offsetDistance;
        textY = pathY;
      } else {
        const radians = (rotate * Math.PI) / 180;
        textX = pathX + offsetDistance * Math.sin(radians);
        textY = pathY - offsetDistance * Math.cos(radians);
      }

      h.append("text")
        .attr("x", textX)
        .attr("y", textY)
        .text(`${house ? house.number : "-"}`)
        .attr("font-size", 1.5)
        .attr("fill", "#1e8ecc")
        .attr("text-anchor", "middle")
        .attr("transform", `rotate(${-rotate}, ${textX}, ${textY})`);

      this.drawTooltip(h, `House: ${house.number} (${house.before}V -> ${house.after}V)`);
    },
    drawSemiDetachedHouse(estate, x, y, rotate = 0) {
      const lineStartX = 2,
        lineStartY = 0;
      const lineEndX = 0,
        lineEndY = 0;

      const pathX1 = 3.5; // Position for the first house's symbol
      const pathY1 = -1.3; // Position for the first house's symbol
      const pathX2 = 3.5; // Position for the second house's symbol
      const pathY2 = 1.3; // Position for the second house's symbol

      const iconCenterX = 1;
      const iconCenterY = -0.5;

      let h = this.svg
        .append("g")
        .attr("class", "semi-detached-house")
        .attr("transform", `translate(${x},${y}) rotate(${rotate}, ${iconCenterX}, ${iconCenterY})`);

      h.append("line")
        .style("stroke", "#1b428b")
        .style("stroke-width", 0.2)
        .attr("x1", lineStartX)
        .attr("y1", lineStartY)
        .attr("x2", lineEndX)
        .attr("y2", lineEndY);

      h.append("line")
        .style("stroke", "#1b428b")
        .style("stroke-width", 0.2)
        .attr("x1", lineStartX - 1)
        .attr("y1", lineStartY + 1)
        .attr("x2", lineEndX)
        .attr("y2", lineEndY)
        .attr("transform", `translate(2, 0)`);

      h.append("path")
        .attr("fill", "none")
        .attr("stroke", "#1b428b")
        .attr("stroke-width", 0.2)
        .attr("d", d3.symbol().size(1))
        .attr("transform", `translate(${pathX1}, ${pathY1})`);

      h.append("line")
        .style("stroke", "#1b428b")
        .style("stroke-width", 0.2)
        .attr("x1", lineStartX - 1)
        .attr("y1", lineStartY)
        .attr("x2", lineEndX)
        .attr("y2", lineEndY + 1)
        .attr("transform", `translate(2, -1)`);

      h.append("path")
        .attr("fill", "none")
        .attr("stroke", "#1b428b")
        .attr("stroke-width", 0.2)
        .attr("d", d3.symbol().size(1))
        .attr("transform", `translate(${pathX2}, ${pathY2})`);

      const offsetDistance = 1;
      let textX1, textY1, textX2, textY2;

      if (rotate === 0) {
        textX1 = pathX1 + 1.7;
        textY1 = pathY1 - offsetDistance + 1.5;
        textX2 = pathX2 + 1.7;
        textY2 = pathY2 + offsetDistance - 1.5;
      } else if (rotate === 90) {
        textX1 = pathX1 + offsetDistance + 1;
        textY1 = pathY1;
        textX2 = pathX2 + offsetDistance + 1;
        textY2 = pathY2;
      } else if (rotate === 180) {
        textX1 = pathX1 + 2;
        textY1 = pathY1 + offsetDistance - 1.5;
        textX2 = pathX2 + 2;
        textY2 = pathY2 + offsetDistance - 1.5;
      } else if (rotate === 270) {
        textX1 = pathX1 + offsetDistance;
        textY1 = pathY1;
        textX2 = pathX2 + offsetDistance;
        textY2 = pathY2;
      } else {
        const radians = (rotate * Math.PI) / 180;
        textX1 = pathX1 + offsetDistance * Math.sin(radians);
        textY1 = pathY1 - offsetDistance * Math.cos(radians);
        textX2 = pathX2 + offsetDistance * Math.sin(radians);
        textY2 = pathY2 - offsetDistance * Math.cos(radians);
      }

      h.append("text")
        .attr("x", textX1)
        .attr("y", textY1)
        .text(`${estate && estate[0] ? estate[0].number : "-"}`)
        .attr("font-size", 1.5)
        .attr("fill", "#1e8ecc")
        .attr("text-anchor", "middle")
        .attr("transform", `rotate(${-rotate}, ${textX1}, ${textY1})`);

      h.append("text")
        .attr("x", textX2)
        .attr("y", textY2)
        .text(`${estate && estate[0] ? estate[1].number : "-"}`)
        .attr("font-size", 1.5)
        .attr("fill", "#1e8ecc")
        .attr("text-anchor", "middle")
        .attr("transform", `rotate(${-rotate}, ${textX2}, ${textY2})`);

      this.drawTooltip(
        h,
        `House: ${estate[0].number} (${estate[0].before}V -> ${estate[0].after}V) & House: ${estate[1].number} (${estate[1].before}V -> ${estate[1].after}V)`
      );
    },
    getData() {
      // Dummy data structure
      this.data = [
        {
          id: "line_1",
          direction: 90,
          house_on: "right",
          number_of_houses: 3,
          houses: [
            [
              {
                id: "70",
                name: "70",
                type: "semi-detached",
                location: "top",
              },
              {
                id: "34",
                name: "34",
                type: "semi-detached",
                location: "bottom",
              },
            ],
            /*
            [
              {
                id: "67",
                name: "67",
                type: "detached",
                location: "right",
              },
            ],
            [
              {
                id: "47",
                name: "47",
                type: "semi-detached",
                location: "top",
              },
              {
                id: "83",
                name: "83",
                type: "semi-detached",
                location: "bottom",
              },
            ],
            [
              {
                id: "74",
                name: "74",
                type: "semi-detached",
                location: "top",
              },
              {
                id: "73",
                name: "73",
                type: "semi-detached",
                location: "bottom",
              },
            ],
            */
          ],
        },
      ];
    },
  },
};
</script>
